import type { BaseOptions } from '../typings';
import { isScriptExist, loadScript } from '../utils';

export class BaseCaptcha {
  key: string;
  captcha: any;
  defaultLang: string;
  lang: string;
  siteKey: string;
  url: string | undefined;
  id: string | undefined;
  ready: boolean;
  loaded: boolean;
  options: BaseOptions;
  injectFunction: any;
  recaptchaElm?: any;

  constructor(options: BaseOptions = {}) {
    this.key = 'recaptcha';
    this.captcha = null;
    this.defaultLang = 'en';
    this.lang = options.lang || this.defaultLang;
    this.siteKey = '';
    this.id = undefined;
    this.ready = false;
    this.loaded = false;
    this.options = options;

    this.url = undefined;
  }

  resize(el: HTMLElement | string | null) {
    // no op
  }

  async load(url?: string) {
    const loadUrl = url || this.url;

    if (this.loaded && isScriptExist(loadUrl)) {
      return true;
    }

    const res = await loadScript({
      src: loadUrl,
      async: false,
    });
    if (!res) {
      console.warn(`[${this.key}] Script can not load`);
      this.loaded = false;
      return false;
    }
    this.loaded = true;
    return true;
  }
}
